import { Box } from '@mui/material'
import { type EventDTO, HorizontalCard, VerticalCard } from '~entities/index'
import { containerSx, items1Sx, items2Sx } from './styles'

export const FourCardsGroup = ({ type, events }: { type: 1 | 2; events: EventDTO[] }) => {
	const isFirstType = type === 1
	const columns = isFirstType
		? [
			{ eventIndex: 0, Card: VerticalCard },
			{ eventIndex: 1, Card: HorizontalCard },
			{ eventIndex: 2, Card: HorizontalCard },
			{ eventIndex: 3, Card: VerticalCard }
		]
		: [
			{ eventIndex: 0, Card: HorizontalCard },
			{ eventIndex: 1, Card: VerticalCard },
			{ eventIndex: 2, Card: VerticalCard },
			{ eventIndex: 3, Card: HorizontalCard }
		]
	return (
		<Box
			minWidth='1072px'
			sx={containerSx}
		>
			{columns.map(({ eventIndex, Card }) => (
				<Card
					key={eventIndex}
					sx={isFirstType ? items1Sx[eventIndex] : items2Sx[eventIndex]}
					info={events[eventIndex]}
					isSmall={Card === VerticalCard}
				/>
			))}
		</Box>
	)
}
